/* eslint-disable react/prop-types */
/* eslint-disable require-jsdoc */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, {useState} from 'react';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import '../css/LegalPage.css';


import PrivacySummary from '../utils/privacyPolicy';
import TermsSummary from '../utils/termsOfUse';
import {AiFillDownCircle, AiFillUpCircle} from 'react-icons/ai';


function Accordion(props) {
  const [isActive, setIsActive] = useState(false);
  return (<>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '1200px',
      }}
      onClick={() => setIsActive(!isActive)}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <span>
          <h1 style={{fontSize: '22px'}}>
            {props.title}&nbsp;&nbsp;
          </h1>
        </span>
        {isActive ? (
          <AiFillUpCircle
            size='20px'
            color='black'
          />
        ) : (
          <AiFillDownCircle size='20px' color='black' />
        )}
      </div>
      <br />

      <br />
    </div>
    {isActive && (
      <div>
        <br />
        {props.children}
      </div>
    )}
  </>);
}


/**
 * @component The component renders the Legal page
 * @return {Component} LegalPage component
 */
export default function LegalPage() {
  return (
    <Card
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <h1>Legal Information </h1>
      <Divider />
      <br />
      <div className="legal-container">
        <br />
        <Accordion title="Legal Disclosures">
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '15px',
          }}>
            <Accordion title="Terms of Use">
              <TermsSummary />
            </Accordion>
            <div style={{height: '20px'}} />
            <Accordion title="Privacy Policy">
              <PrivacySummary />
            </Accordion>
          </div>
        </Accordion>
        <br />
        <br />
      </div>
      <div style={{height: '100px'}} />
    </Card>
  );
}

/**
 * @component The component renders the Legal page
 * @return {Component} LegalPage component
 */
function OldLegalPage() {
  return (
    <Card
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <Typography variant="h6" gutterBottom>
        <h1>Legal Information</h1>
      </Typography>
      <Divider />
      <div className="legal-container">
        <br />
        <p>
          Advanced Intelligence Services, Incorporated 2021 Legal Disclosures
          TERMS OF USE Before using this Web site, please read the Terms of Use
          set forth below. By using this Web site you agree to be bound by the
          Terms of Use. Advanced Intelligence Services, Incorporated and its
          affiliates and subsidiaries ("We" or such conjugation thereof as the
          context may require such as "A.I.S. Corp.'') reserve the right to
          review and revise the Terms of Use from time to time without prior
          notice and, by using this site subsequent to any revision of the Terms
          of Use, you agree to be bound by such changes. If you find the Terms
          of Use to be unacceptable, you must immediately terminate your use of
          this Web site.
        </p>
        {/* {info.map((data, index) => {
          return (
            <Accordion
              key={index}
              title={data.section}
              content={data.text}
              buttonColor="black"
              headingTextSize="22px"
              textSize="20px"
              lineHeight="40px"
              iconSize={20}
              contentTopMargin={-40}
            />
          );
        })} */}
        <br />
        <p>
          DISCLAIMER A.I.S. Corp. is a biological and artificial intelligence
          research provider, exclusively serving the United States Department of
          Defense and it’s long-term allies in emerging defense contexts. A.I.S.
          Corp. is based in Hobart, Indiana, USA. Copyright © 2021 Advanced
          Intelligence Services Corporation All rights reserved.
        </p>
      </div>
    </Card>
  );
}
